class SmartHeader extends HTMLElement {
  constructor() {
    super();
    this.sticky = this.dataset.sticky === 'true';
    this.headerWrapper = this.querySelector('.smart-header__wrapper');
    this.announcementBar = this.querySelector('.smart-announcement-bar');
    
    this.lastScrollY = window.scrollY;
    this.ticking = false;
    this.isHoveringMenu = false;
    this._contrastChecked = false;
    
    this.init();
  }

  init() {
    if (this.sticky) {
      window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    }
    
    this.initAnnouncement();
    this.initIcons();
    this.initLocalization();
    this.initMenuHover();
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.checkBackgroundContrast.bind(this));
    } else {
      this.checkBackgroundContrast();
    }

    window.addEventListener('load', this.checkBackgroundContrast.bind(this));
  }

  constrainDropdownHeight(item) {
    const dropdown = item.querySelector('.smart-header__dropdown');
    if (!dropdown) return;

    dropdown.style.removeProperty('max-height');
    dropdown.style.removeProperty('overflow');

    const bannerCol = dropdown.querySelector('.smart-header__banner-column');
    const sbCard = dropdown.querySelector('.sb-card');

    if (bannerCol) {
      bannerCol.style.removeProperty('height');
      bannerCol.style.removeProperty('min-height');
    }
    if (sbCard) {
      sbCard.style.removeProperty('height');
      sbCard.style.removeProperty('min-height');
      sbCard.style.removeProperty('aspect-ratio');
    }

    setTimeout(() => {
      const dropdownRect = dropdown.getBoundingClientRect();
      const availableHeight = window.innerHeight - dropdownRect.top - 16;

      if (dropdown.scrollHeight > availableHeight) {
        dropdown.style.setProperty('max-height', availableHeight + 'px', 'important');

        if (bannerCol) {
          bannerCol.style.setProperty('height', '100%', 'important');
          bannerCol.style.setProperty('min-height', '0', 'important');
        }
        if (sbCard) {
          sbCard.style.setProperty('height', '100%', 'important');
          sbCard.style.setProperty('min-height', '0', 'important');
          sbCard.style.setProperty('aspect-ratio', 'auto', 'important');
        }
      }
    }, 50);
  }

  fixSubDropdownPosition(subDropdown, parentLi) {
    subDropdown.style.top = '';

    const parentRect = parentLi.getBoundingClientRect();
    const subHeight = subDropdown.offsetHeight;
    const spaceBelow = window.innerHeight - parentRect.top - 20;

    if (subHeight > spaceBelow) {
      const newTop = -(subHeight - spaceBelow);
      subDropdown.style.top = Math.min(0, newTop) + 'px';
    } else {
      subDropdown.style.top = '0';
    }
  }

  initMenuHover() {
    const menuItems = this.querySelectorAll('.smart-header__menu-item.has-dropdown');

    let closeTimer = null;

    const cancelClose = () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };

    const scheduleClose = () => {
      cancelClose();

      closeTimer = setTimeout(() => {
        // Ne ferme que si la souris n'est plus sur aucun menu dropdown
        const hoveringDropdown = Array.from(menuItems).some(item =>
          item.matches(':hover')
        );

        if (!hoveringDropdown) {
          menuItems.forEach(item => {
            item.classList.remove('is-active');
          });

          this.classList.remove('mega-menu-open');
        }

        closeTimer = null;
      }, 250);
    };

    menuItems.forEach(item => {

      item.addEventListener('mouseenter', () => {
        this.isHoveringMenu = true;
        cancelClose();

        menuItems.forEach(other => {
          if (other !== item) {
            other.classList.remove('is-active');
          }
        });

        item.classList.add('is-active');
        this.classList.add('mega-menu-open');

        this.constrainDropdownHeight(item);

        const images = item.querySelectorAll('img');

        images.forEach(img => {
          if (!img.complete) {
            img.addEventListener('load', () => {
              if (item.classList.contains('is-active')) {
                this.constrainDropdownHeight(item);
              }
            }, { once: true });
          }
        });
      });

      item.addEventListener('mouseleave', () => {
        this.isHoveringMenu = false;
        scheduleClose();
      });

      const subDropdowns = item.querySelectorAll('.smart-header__sub-dropdown');

      subDropdowns.forEach(sub => {
        sub.addEventListener('mouseenter', () => {
          this.isHoveringMenu = true;
          cancelClose();
        });

        sub.addEventListener('mouseleave', () => {
          this.isHoveringMenu = false;
          scheduleClose();
        });
      });

      const subDropdownTriggers = item.querySelectorAll('.has-sub-dropdown');

      subDropdownTriggers.forEach(trigger => {
        trigger.addEventListener('mouseenter', () => {
          const subDropdown = trigger.querySelector('.smart-header__sub-dropdown');

          if (subDropdown) {
            requestAnimationFrame(() => {
              this.fixSubDropdownPosition(subDropdown, trigger);
            });
          }
        });
      });

    });

    window.addEventListener('resize', () => {
      const activeItem = this.querySelector('.smart-header__menu-item.is-active');

      if (activeItem) {
        this.constrainDropdownHeight(activeItem);
      }
    }, { passive: true });
  }

  initIcons() {
    document.fonts.ready.then(() => {
      document.body.classList.add('icons-loaded');
    });
  }

  onScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.updateHeaderState();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  updateHeaderState() {
    const currentScrollY = window.scrollY;
    const threshold = 100;
    const tolerance = 10;

    if (currentScrollY > 20) {
      this.classList.add('is-scrolled');
      this.classList.remove('has-dark-bg');
      this._contrastChecked = false;
    } else {
      this.classList.remove('is-scrolled');
      if (!this._contrastChecked) {
        this._contrastChecked = true;
        this.checkBackgroundContrast();
      }
    }

    if (currentScrollY <= 0) {
      this.classList.remove('is-hidden');
      return;
    }

    if (this.isHoveringMenu) {
      this.classList.remove('is-hidden');
      return;
    }

    if (Math.abs(currentScrollY - this.lastScrollY) <= tolerance) {
      return; 
    }
/*
    if (currentScrollY > this.lastScrollY && currentScrollY > threshold) {
      this.classList.add('is-hidden');
    } else {
      this.classList.remove('is-hidden');
    }
*/
    this.classList.remove('is-hidden');

    this.lastScrollY = currentScrollY;
  }

  initAnnouncement() {
    if (!this.announcementBar) return;

    const slides = this.announcementBar.querySelectorAll('.smart-announcement-slide');
    if (slides.length < 2) return;

    const delay = parseInt(this.announcementBar.dataset.delay) * 1000 || 3000;
    let currentIndex = 0;

    setInterval(() => {
      slides[currentIndex].classList.remove('active');
      currentIndex = (currentIndex + 1) % slides.length;
      slides[currentIndex].classList.add('active');
    }, delay);
  }

  initLocalization() {
    const trigger = this.querySelector('.js-localization-trigger');
    const dropdown = this.querySelector('#LocalizationDropdown');
    
    if (!trigger || !dropdown) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      dropdown.classList.toggle('is-open');
    });

    document.addEventListener('click', (e) => {
      if (!trigger.contains(e.target) && !dropdown.contains(e.target)) {
        dropdown.classList.remove('is-open');
      }
    });

    const links = dropdown.querySelectorAll('.localization-link');
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const locale = link.dataset.value;
        const form = dropdown.querySelector('form');
        const input = form.querySelector('input[name="locale_code"]');
        
        if (input && locale) {
          input.value = locale;
          form.submit();
        }
      });
    });
  }

  checkBackgroundContrast() {
    if (this.classList.contains('is-scrolled')) return;

    const selectors = [
      '.shopify-section:first-child img',
      '.shopify-section:first-child video',
      'main img:first-of-type',
      '.hero-banner img'
    ];
    
    let candidate = null;
    for (const selector of selectors) {
      const el = document.querySelector(selector);
      if (el) {
        candidate = el;
        break;
      }
    }
    
    if (!candidate) return;

    const analyze = (mediaElement) => {
      try {
        const src = mediaElement.src || mediaElement.currentSrc || '';
        if (src && !src.includes(window.location.hostname) && !src.includes('cdn.shopify.com')) {
          return;
        }

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = 100;
        canvas.height = 50; 
        context.drawImage(mediaElement, 0, 0, 100, 50);
        const data = context.getImageData(0, 0, 100, 50).data;
        
        let r, g, b, avg;
        let colorSum = 0;
        let count = 0;

        for (let x = 0, len = data.length; x < len; x += 4) {
          r = data[x];
          g = data[x + 1];
          b = data[x + 2];
          avg = Math.floor(0.2126 * r + 0.7152 * g + 0.0722 * b);
          colorSum += avg;
          count++;
        }

        const brightness = Math.floor(colorSum / count);
        
        if (brightness < 110) {
          this.classList.add('has-dark-bg');
        } else {
          this.classList.remove('has-dark-bg');
        }
      } catch (e) {
      }
    };

    if (candidate.tagName === 'IMG') {

        // skip loyalty pages
      if (window.location.pathname.includes('le-club-bijo') || window.location.pathname.includes('the-club-bijo')) {
        return;
      }
      if (candidate.complete && candidate.naturalWidth > 0) {
        candidate.crossOrigin = "Anonymous";
        analyze(candidate);
      } else {
        candidate.crossOrigin = "Anonymous";
        candidate.addEventListener('load', () => analyze(candidate));
      }
    } else if (candidate.tagName === 'VIDEO') {
      if (candidate.readyState >= 2) {
         analyze(candidate);
      } else {
         candidate.addEventListener('loadeddata', () => analyze(candidate));
      }
    }
  }
}

customElements.define('smart-header', SmartHeader);